import React from 'react'

import { SignDocument } from 'components/SignDocument'

export interface SignDocumentViewProps {
  status: string
}

export const SignDocumentView = (props: SignDocumentViewProps) => {
  const isSuccessful = props.status === 'success'
  const headerNode = isSuccessful ? (
    <h1>Thank you!</h1>
  ) : (
    <h1>Oops, something went wrong!</h1>
  )
  const paragraphNode = isSuccessful ? (
    <p>Your signature has been added successfully.</p>
  ) : (
    <p>
      Your signature could not be added to the document. Please{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="mailto:admin@sitefile.com">
        contact an administrator
      </a>{' '}
      for more information.
    </p>
  )

  return <SignDocument header={headerNode} body={paragraphNode} />
}
